import QRCode from "qrcode";
import timLama from "../../Assets/tim-lama.jpeg";

export async function generateQRWithLogo(text) {
  const canvas = document.createElement("canvas");

  await QRCode.toCanvas(canvas, text, {
    width: 300,
    errorCorrectionLevel: "H",
  });

  const ctx = canvas.getContext("2d");

  const logo = new Image();
  logo.src = timLama;

  await new Promise((resolve) => {
    logo.onload = resolve;
  });

  const size = 60;
  const x = (canvas.width - size) / 2;
  const y = (canvas.height - size) / 2;

  ctx.drawImage(logo, x, y, size, size);

  return canvas.toDataURL("image/png");
}
